export default __webpack_public_path__ + "static/media/precise-location-selected.4efa2940.svg";